import { googleTagManager } from './tracking';
import { applySubmitComponentType, shouldTrackApplySubmit, usesEfcTracking } from './tracking/delco-tracking';
import {
    BUSINESS_MODEL,
    perCityLandingBusinessModel,
    trackModelApplyNowClick,
    trackBusinessModelClick,
} from './tracking/delivery-model-tracking';
import { novaEventTracker } from './nova-event-tracker';
import { $, $$ } from './utils';

function cityParamFromApplyHref(href) {
    try {
        const q = new URL(href, window.location.origin).searchParams.get('city');
        const t = q?.trim();
        return t ? t.toLowerCase() : null;
    } catch {
        return null;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    //footer link
    const footerLinks = $$('.footer__item a, .footer__city_item a');
    footerLinks.forEach((footerLink) => {
        footerLink.addEventListener('click', () => {
            googleTagManager.trackEventWithName('hasClickedFooterLink');
        });
    });

    const stickyCtaButtons = [
        { el: $('#sticky_apply_now__button_redirect'), componentName: 'cta_sticky_apply_redirect' },
        { el: $('#sticky_apply_now__button'), componentName: 'cta_sticky_apply' },
        { el: $('#signup_form_button'), componentName: 'cta_signup_form' },
    ];

    stickyCtaButtons.forEach(({ el, componentName }) => {
        if (el) {
            el.addEventListener('click', (e) => {
                delayHrefClick(e);
                // EFC Apply Now taps emit 'apply_submit' only (see below)
                if (!usesEfcTracking()) {
                    googleTagManager.trackCtaApplyForm();
                }
                novaEventTracker.trackSoftConversion({ componentName });
                // Dual model per city IC and EM pages: the sticky bar opens the form (a click without a city is stopped before)
                if (perCityLandingBusinessModel()) {
                    trackModelApplyNowClick(perCityLandingBusinessModel());
                }
            });
        }
    });

    // Track clicks on dynamically rendered job posting CTA buttons using event delegation (handles re-renders)
    document.addEventListener('click', (e) => {
        const target = e.target;

        if (!(target instanceof Element)) return;

        const button = target.closest('.job-postings-button');
        if (!button) return;

        delayHrefClick(e);
        novaEventTracker.trackSoftConversion({
            componentName: 'cta_job_posting',
            cityOverride: cityParamFromApplyHref(button.getAttribute('href') || ''),
        });
        googleTagManager.trackCtaApplyForm('cta_job_posting');

        if (shouldTrackApplySubmit()) {
            googleTagManager.trackApplySubmit(applySubmitComponentType(), 'job postings');
        }
    });

    // Delco apply buttons tracking
    const delcoSignupButton = $('#delco-signup-button');

    if (delcoSignupButton) {
        delcoSignupButton.addEventListener('click', (e) => {
            novaEventTracker.trackSoftConversion({ componentName: 'cta_delco_signup' });
            if (shouldTrackApplySubmit()) {
                delayHrefClick(e);
                googleTagManager.trackApplySubmit(applySubmitComponentType(), 'introduction');
            }
        });
    }

    // CTA button tracking
    const scooberApplyButton = $('#sticky_apply_now__button_redirect');
    const delcoStickyApply = $('#sticky_apply_now__button_redirect_delco');
    const scooberHeroApplyButton = $('#application_button');
    if (scooberApplyButton) {
        scooberApplyButton.addEventListener('click', (e) => {
            if (shouldTrackApplySubmit()) {
                delayHrefClick(e);
                googleTagManager.trackApplySubmit(applySubmitComponentType(), 'bottom');
            }
        });
    }

    if (delcoStickyApply) {
        delcoStickyApply.addEventListener('click', (e) => {
            novaEventTracker.trackSoftConversion({ componentName: 'cta_sticky_apply_redirect_delco' });
            if (shouldTrackApplySubmit()) {
                delayHrefClick(e);
                googleTagManager.trackApplySubmit(applySubmitComponentType(), 'bottom');
            }
        });
    }

    if (scooberHeroApplyButton) {
        scooberHeroApplyButton.addEventListener('click', (e) => {
            delayHrefClick(e);
            const componentName = window.hasExternalApplyForm ? 'cta_basic_hero_external' : 'cta_basic_hero';
            novaEventTracker.trackSoftConversion({ componentName });
            if (shouldTrackApplySubmit()) {
                googleTagManager.trackApplySubmit(applySubmitComponentType(), 'introduction');
            } else {
                googleTagManager.trackCtaApplyForm();
            }
            // Dual model per city: apply on the IC and EM pages; Dual model Employee + IC: the model choice on the neutral page, apply on the IC page
            if (perCityLandingBusinessModel()) {
                trackModelApplyNowClick(perCityLandingBusinessModel());
            } else if (window.isIcLandingPage) {
                trackModelApplyNowClick();
            } else if (window.page === 'home') {
                trackBusinessModelClick(BUSINESS_MODEL.EM);
            }
        });
    }

    // IC hero CTA next to the employee one on the neutral page of an IC-model country
    const icHeroApplyButton = $('#ic_application_button');
    if (icHeroApplyButton) {
        icHeroApplyButton.addEventListener('click', (e) => {
            delayHrefClick(e);
            novaEventTracker.trackSoftConversion({ componentName: 'cta_basic_hero_ic' });
            trackBusinessModelClick(BUSINESS_MODEL.IC);
        });
    }

    //faq section
    const faqItems = $$("[id^='faq-trigger']");
    faqItems.forEach((faqItem) => {
        faqItem.addEventListener('click', () => {
            let checkbox = faqItem.previousElementSibling;
            if (checkbox.tagName.toLowerCase() === 'input') {
                if (checkbox.checked === false) {
                    //open
                    if (faqItem.id.includes('courier_hub')) {
                        googleTagManager.trackEventWithName('faq_open', {
                            customData: {
                                component_name: faqItem.firstElementChild.innerHTML,
                                component_type: 'faq',
                                component_action: 'open',
                            },
                        });
                    } else {
                        googleTagManager.trackEventWithName('hasOpenedFaqModal', {
                            customData: {
                                faqQuestion: faqItem.firstElementChild.innerHTML,
                            },
                        });
                    }
                } else if (checkbox.checked === true) {
                    //close
                    if (faqItem.id.includes('courier_hub')) {
                        googleTagManager.trackEventWithName('faq_close', {
                            customData: {
                                component_name: faqItem.firstElementChild.innerHTML,
                                component_type: 'faq',
                                component_action: 'close',
                            },
                        });
                    } else {
                        googleTagManager.trackEventWithName('hasClosedFaqModal', {
                            customData: {
                                faqQuestion: faqItem.firstElementChild.innerHTML,
                            },
                        });
                    }
                }
            }
        });
    });
    const faqCloseButtons = $$("[id^='faq-modal-close']");
    faqCloseButtons.forEach((faqCloseButton) => {
        faqCloseButton.addEventListener('click', () => {
            let question = faqCloseButton.parentElement.parentElement.querySelector('p').innerHTML;
            googleTagManager.trackEventWithName('hasClosedFaqModal', {
                customData: {
                    faqQuestion: question,
                },
            });
        });
    });

    //testimonials
    const testimonials = $('#testimonials-row');
    if (testimonials) {
        const prevArrow = testimonials.querySelector('.carousel__arrow--prev');
        const nextArrow = testimonials.querySelector('.carousel__arrow--next');
        nextArrow.addEventListener('click', () => {
            googleTagManager.trackEventWithName('hasClickedNextTestimonial');
        });
        prevArrow.addEventListener('click', () => {
            googleTagManager.trackEventWithName('hasClickedPreviousTestimonial');
        });
    }

    // Courier Hub
    const category = $('#blog-category-title-id');

    // Help Center (subcategories)
    const helpCenterSubcategory = $('.blog-category-help-center');

    if (category && !helpCenterSubcategory) {
        googleTagManager.trackEventWithName('general_category', {
            customData: {
                component_type: 'category',
                component_action: 'load',
                category_name: category.textContent.trim(),
            },
        });
    } else if (category && helpCenterSubcategory) {
        googleTagManager.trackEventWithName('help_center', {
            customData: {
                component_name: 'general_category',
                component_type: 'help_center',
                component_action: 'load',
                category_name: category.textContent.trim(),
            },
        });
    }

    // Article (blog post)
    const blogTitle = $('#blogPostTitleId');
    const blogCategory = $('#blogCategoryId');
    const blogContent = $('.blog-section');
    const helpCenterArticle = $('#tracking-help-center-article');
    let scrolled50Percent,
        scrolled90percent = false;

    if (blogTitle && blogCategory) {
        googleTagManager.trackEventWithName('article', {
            customData: {
                component_type: 'article',
                component_action: 'load',
                category_name: helpCenterArticle
                    ? blogCategory.textContent.trim() + ' - help center'
                    : blogCategory.textContent.trim(),
                article_name: blogTitle.textContent.trim(),
            },
        });
    }

    document.addEventListener('scroll', () => {
        if (blogContent && (!scrolled50Percent || !scrolled90percent)) {
            if (window.innerHeight * 0.5 <= window.scrollY && !scrolled50Percent) {
                scrolled50Percent = true;
                googleTagManager.trackEventWithName('scroll', {
                    customData: {
                        component_type: 'scroll',
                        article_name: blogTitle.textContent.trim(),
                        scroll_action: 50 + '%',
                    },
                });
            }
            if (window.innerHeight * 0.9 <= window.scrollY && !scrolled90percent) {
                scrolled90percent = true;
                googleTagManager.trackEventWithName('scroll', {
                    customData: {
                        component_type: 'scroll',
                        article_name: blogTitle.textContent.trim(),
                        scroll_action: 90 + '%',
                    },
                });
            }
        }
    });

    // CTA Button Click
    const ctaButton = $('#home_ready_button_courier_hub');
    const stickyCtaButton = $('#home_ready_button_courier_hub_sticky');
    const ctaButtonContainer = $('#home_ready_button_courier_hub_interested');

    if (ctaButton) {
        ctaButton.addEventListener('click', () => {
            googleTagManager.trackCtaApply();
        });
    }

    if (stickyCtaButton) {
        stickyCtaButton.addEventListener('click', () => {
            googleTagManager.trackCtaApply();
        });
    }

    if (ctaButtonContainer) {
        ctaButtonContainer.addEventListener('click', () => {
            googleTagManager.trackCtaApply();
        });
    }

    // UEFA banner button
    const UEFAButton = $('#UEFA-button');
    if (UEFAButton) {
        UEFAButton.addEventListener('click', () => {
            googleTagManager.trackEventWithName('cta', {
                customData: {
                    component_name: window.location.href,
                    component_type: 'cta',
                    component_action: 'cta_uefa',
                },
            });
        });
    }

    // Country page scroll event
    const countryPage = $('#app');
    const isFormPage = window.page === 'form';

    let scrolledCountryPage50,
        scrolledCountryPage65,
        scrolledCountryPage80 = false;

    document.addEventListener('scroll', () => {
        if (countryPage && !isFormPage && (!scrolledCountryPage50 || !scrolledCountryPage80)) {
            let scrollPosition = window.scrollY;
            let windowSize = window.innerHeight;
            let bodyHeight = document.body.offsetHeight;
            let scrollPercentage = (scrollPosition / (bodyHeight - windowSize)) * 100;
            if (scrollPercentage >= 50 && !scrolledCountryPage50) {
                googleTagManager.trackEventWithName('scroll', {
                    customData: {
                        component_name: 'recruitment page',
                        component_type: 'scroll',
                        scroll_action: 50 + '%',
                    },
                });

                scrolledCountryPage50 = true;
            }
            if (scrollPercentage >= 65 && !scrolledCountryPage65) {
                googleTagManager.trackEventWithName('scroll', {
                    customData: {
                        component_name: 'recruitment page',
                        component_type: 'scroll',
                        scroll_action: 65 + '%',
                    },
                });
                scrolledCountryPage65 = true;
            }
            if (scrollPercentage >= 80 && !scrolledCountryPage80) {
                googleTagManager.trackEventWithName('scroll', {
                    customData: {
                        component_name: 'recruitment page',
                        component_type: 'scroll',
                        scroll_action: 80 + '%',
                    },
                });
                scrolledCountryPage80 = true;
            }
        }
    });
});

function delayHrefClick(event, delay = 100) {
    if (event.defaultPrevented) return;

    const href = event.target?.closest?.('a')?.href;
    if (href) {
        event.preventDefault();
        setTimeout(function () {
            window.location = href;
        }, delay);
    }
}
